import styled from 'styled-components'

export const ConatinerHome= styled.div`
background: #0f0e17;
height:auto;
`
